import type { CSSProperties } from 'react';
import { WEDGE_SETTINGS_ACTION } from '@territory/tokens';
import { wedgeExactRole } from './wedgeRoles.js';

export type WedgePhoneBannerLook = 'phone-banner-stale' | 'phone-banner-promise' | 'phone-banner-promise-recovering';
export const isWedgePhoneBannerLook = (look: string | undefined): look is WedgePhoneBannerLook => !!look && look.startsWith('phone-banner-');

// Fixed Phone overlays: the stale-shell refresh pill and the desktop promise strip. Neither draws a transparent hit area.
export function wedgePhoneBannerStyle(look: WedgePhoneBannerLook): CSSProperties {
  if (look === 'phone-banner-stale') return {
    position: 'fixed', left: '50%', transform: 'translateX(-50%)',
    bottom: 'calc(72px + env(safe-area-inset-bottom))', zIndex: 90,
    display: 'inline-flex', alignItems: 'center', gap: 7,
    padding: '9px 15px', borderRadius: 999,
    background: wedgeExactRole('bgElev'), color: wedgeExactRole('label'),
    border: `1px solid ${wedgeExactRole('accent')}`,
    boxShadow: WEDGE_SETTINGS_ACTION.stalePillShadow,
    fontSize: 12.5, fontWeight: 700, fontFamily: wedgeExactRole('font'),
    cursor: 'pointer', WebkitTapHighlightColor: 'transparent',
  };
  return {
    position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9990,
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
    padding: 'calc(env(safe-area-inset-top, 44px) + 4px) 12px 6px',
    background: wedgeExactRole(look === 'phone-banner-promise-recovering' ? 'amber' : 'accent'),
    color: WEDGE_SETTINGS_ACTION.promiseInk, border: 0, cursor: 'pointer',
    fontFamily: wedgeExactRole('font'), fontSize: 12, fontWeight: 600, letterSpacing: 0.2,
    boxShadow: WEDGE_SETTINGS_ACTION.promiseShadow,
  };
}
